import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-dark-navy via-[#0D1128] to-dark-navy font-cairo">
      <div className="fixed inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgwLDIxNywyNTUsMC4wNSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30 pointer-events-none"></div>
      
      <Navbar />

      <main className="relative">
        {/* Hero Section */}
        <section className="pt-32 pb-20 px-6">
          <div className="container mx-auto">
            <div className="text-center mb-16">
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
                طيبات الطبية العالمية
              </h1>
              <p className="text-3xl md:text-4xl text-neon-cyan font-bold mb-4">
                تجارة طبية دولية
              </p>
              <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                استثمار تشغيلي شفاف في قطاع الأجهزة الطبية والمستلزمات الطبية
              </p>
            </div>

            {/* Metrics Cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/20 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-calendar-line text-3xl text-neon-cyan"></i>
                </div>
                <div className="text-4xl font-bold text-white mb-2">2017</div>
                <div className="text-sm text-gray-400">سنة التأسيس</div>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/20 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-global-line text-3xl text-neon-green"></i>
                </div>
                <div className="text-4xl font-bold text-white mb-2">3</div>
                <div className="text-sm text-gray-400">أسواق دولية</div>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/20 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-file-list-3-line text-3xl text-neon-green"></i>
                </div>
                <div className="text-4xl font-bold text-white mb-2">71</div>
                <div className="text-sm text-gray-400">عدد الصفقات</div>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-green/20 rounded-2xl p-6 text-center hover:shadow-lg hover:shadow-neon-green/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-line-chart-line text-3xl text-neon-green"></i>
                </div>
                <div className="text-4xl font-bold text-white mb-2">~27%</div>
                <div className="text-sm text-gray-400">متوسط العائد السنوي</div>
              </div>
            </div>
          </div>
        </section>

        {/* Investment Methodology Preview */}
        <section className="py-20 px-6">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                كيف نوظف رأس مالك
              </h2>
              <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                نتبع منهجية استثمارية شفافة ومدروسة لضمان أفضل العوائد مع إدارة المخاطر بفعالية
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-cyan/10 rounded-xl mb-4">
                  <i className="ri-search-line text-3xl text-neon-cyan"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">تحديد الصفقة</h3>
                <p className="text-gray-400 leading-relaxed">
                  نبحث عن فرص استثمارية مدروسة في قطاع الأجهزة الطبية مع شركاء موثوقين
                </p>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-cyan/10 rounded-xl mb-4">
                  <i className="ri-shield-check-line text-3xl text-neon-cyan"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">تقييم المخاطر</h3>
                <p className="text-gray-400 leading-relaxed">
                  تحليل شامل للمخاطر المالية والتشغيلية قبل اتخاذ أي قرار استثماري
                </p>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-cyan/10 rounded-xl mb-4">
                  <i className="ri-bank-line text-3xl text-neon-cyan"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">تمويل الشراء</h3>
                <p className="text-gray-400 leading-relaxed">
                  نستخدم رأس المال المتاح لشراء المنتجات الطبية من الموردين المعتمدين
                </p>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-green/10 rounded-xl mb-4">
                  <i className="ri-ship-line text-3xl text-neon-green"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">التصدير بضمانات</h3>
                <p className="text-gray-400 leading-relaxed">
                  نصدر المنتجات مع ضمانات بنكية لحماية رأس المال والأرباح المتوقعة
                </p>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-green/10 rounded-xl mb-4">
                  <i className="ri-truck-line text-3xl text-neon-green"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">المتابعة اللوجستية</h3>
                <p className="text-gray-400 leading-relaxed">
                  متابعة دقيقة لعمليات الشحن والتخليص الجمركي حتى وصول المنتجات
                </p>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 hover:border-neon-cyan/50 hover:shadow-lg hover:shadow-neon-cyan/10 transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-neon-green/10 rounded-xl mb-4">
                  <i className="ri-money-dollar-circle-line text-3xl text-neon-green"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">التحصيل والتوزيع</h3>
                <p className="text-gray-400 leading-relaxed">
                  تحصيل الأرباح وتوزيعها على المستثمرين أو إعادة استثمارها حسب الاتفاق
                </p>
              </div>
            </div>

            <div className="text-center">
              <Link
                to="/investment-methodology"
                className="inline-flex items-center gap-2 px-8 py-3 bg-neon-cyan text-white font-semibold rounded-lg hover:bg-neon-cyan/90 hover:shadow-lg hover:shadow-neon-cyan/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                اعرف المزيد
                <i className="ri-arrow-left-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Achievements Section */}
        <section className="py-20 px-6 bg-gradient-to-b from-transparent to-dark-navy/50">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                إنجازات موثقة وشفافية كاملة
              </h2>
              <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                سجل حافل من النجاحات والشراكات الاستراتيجية مع أبرز الشركات العالمية
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-neon-cyan/20 to-transparent rounded-full">
                  <i className="ri-building-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">ResMed</h3>
                <p className="text-gray-400 text-sm">أجهزة التنفس الصناعي</p>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-neon-cyan/20 to-transparent rounded-full">
                  <i className="ri-building-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">BMC</h3>
                <p className="text-gray-400 text-sm">أجهزة طبية متقدمة</p>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-neon-cyan/20 to-transparent rounded-full">
                  <i className="ri-building-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Yuwell</h3>
                <p className="text-gray-400 text-sm">مستلزمات طبية</p>
              </div>
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-neon-cyan/20 to-transparent rounded-full">
                  <i className="ri-building-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Medel</h3>
                <p className="text-gray-400 text-sm">تقنيات طبية حديثة</p>
              </div>
            </div>

            <div className="text-center">
              <Link
                to="/achievements"
                className="inline-flex items-center gap-2 px-8 py-3 bg-neon-green text-dark-navy font-semibold rounded-lg hover:bg-neon-green/90 hover:shadow-lg hover:shadow-neon-green/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                عرض السجل الكامل
                <i className="ri-arrow-left-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Legal Notice */}
        <section className="py-20 px-6">
          <div className="container mx-auto max-w-4xl">
            <div className="bg-gradient-to-br from-red-900/30 to-pink-900/30 border-2 border-red-500/50 rounded-2xl p-8 shadow-lg shadow-red-500/20">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-red-500/20 rounded-full flex-shrink-0">
                  <i className="ri-alert-line text-2xl text-red-400"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-4">تنويه قانوني هام</h3>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    هذا الموقع مخصص لعرض معلومات عن نشاط طيبات الطبية العالمية في مجال التجارة الطبية الدولية. جميع الأرقام والبيانات المعروضة هي لأغراض توضيحية فقط.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    <strong className="text-white">تحذير:</strong> الاستثمار في التجارة الدولية ينطوي على مخاطر. الأداء السابق لا يضمن النتائج المستقبلية. يجب على المستثمرين المحتملين إجراء العناية الواجبة الخاصة بهم واستشارة مستشارين ماليين وقانونيين مستقلين قبل اتخاذ أي قرارات استثمارية.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
